import React, { FC } from 'react'

export const Conversions: FC = () => (
  <svg
    width="121"
    height="82"
    viewBox="0 0 121 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M59.487 75.286H28.154a2.325 2.325 0 0 1-2.322-2.33V38.29a2.328 2.328 0 0 1 2.322-2.332h52.162a2.328 2.328 0 0 1 2.323 2.332v12.383"
      stroke="#89BEF8"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.9 47.387H34.572v-6.723H73.9v6.723ZM35.918 54.11h23.53M35.918 58.48h23.53M31.21 66.546h18.152M30.54 70.58h18.15M79.615 54.95c0 1.949-3.614 3.53-8.069 3.53-4.455 0-8.066-1.581-8.066-3.53 0-1.95 3.61-3.53 8.066-3.53 4.455 0 8.069 1.58 8.069 3.53ZM63.48 59.847c1.094 1.547 4.244 2.666 7.962 2.666 3.994 0 7.34-1.296 8.173-3.026M63.48 65.202c1.101 1.561 4.274 2.689 8.012 2.689 1.218 0 2.375-.12 3.417-.34M63.48 71.252c1.082 1.365 4.197 2.353 7.875 2.353 1.14 0 2.23-.097 3.218-.27"
      stroke="#89BEF8"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.254 76.621c-1.327.429-2.96.682-4.728.682-4.442 0-8.045-1.601-8.045-3.575v-18.61M79.615 55.118v6.723"
      stroke="#89BEF8"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.63 74.727c.58.738 1.605 1.23 2.773 1.23 1.812 0 3.278-1.183 3.278-2.648 0-1.384-1.319-2.474-2.996-2.636h.003c-1.524-.106-2.718-1.138-2.718-2.394 0-1.327 1.335-2.405 2.977-2.405 1.047 0 1.966.436 2.497 1.094M84.656 75.958v2.017M84.656 63.521v2.017"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94.74 70.748C94.74 76.408 90.15 81 84.489 81c-5.66 0-10.252-4.591-10.252-10.252 0-5.661 4.591-10.252 10.252-10.252 5.661 0 10.252 4.59 10.252 10.252ZM58.024 18.585v-5.699H61.8l-4.116-5.943L53.563 1l-4.119 5.943-4.116 5.943h3.775v9.29"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.102 28.563v-1.68"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.102 24.865V21.84"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2.91 2.91"
    />
    <path
      d="M58.102 20.496v-1.68"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.41 31.415v-5.608h3.852l-4.2-5.849-4.204-5.848-4.203 5.848-4.2 5.85h3.852v9.142M34.985 31.415v-5.608h-3.774l4.12-5.849 4.115-5.848 4.12 5.848 4.115 5.85h-3.774v9.142"
      stroke="#026AE1"
      strokeWidth="2.017"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
